import Link from 'next/link'
import React from 'react'
import { MarketsNearMeQuery } from 'components/pages/TrucksNearbyPage/types/marketsNearMe'
import cn from 'classnames'

export type GroupedMarketsType = {
  state: string
  markets: MarketsNearMeQuery['markets']['records']
}

type Props = {
  columns: GroupedMarketsType[][]
}
const MarketList = ({ columns }: Props) => {
  return (
    <div
      className={cn(`grid justify-between`, {
        'grid-cols-6': columns.length === 6,
        'grid-cols-2': columns.length === 2
      })}
    >
      {columns.map((markets, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="flex flex-col">
          {markets.map((group, i) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`market-${i}`}
              className="flex mb-2 items-center cursor-pointer pr-2 group md:mb-4 md:pr-4"
            >
              <details>
                <summary className="outline-none-mouse hover:text-orange-800 font-semibold text-lg">
                  {group.state}
                </summary>
                <div>
                  {group.markets.map((m) => (
                    <Link key={m.id} href={m.customerPath} prefetch={false}>
                      <p className="my-2 break-words pl-4 transition-all duration-200 text-gray-800 hover:text-orange-800">
                        {m.name}
                      </p>
                    </Link>
                  ))}
                </div>
              </details>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default MarketList
